import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OverlayOnBeforeShowEvent } from 'primeng/api';
import { SelectModule } from 'primeng/select';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { ComboBoxCustomization } from './combobox-edit';

@Component({
  selector: 'lib-combobox-compiled',
  imports: [ReactiveFormsModule, SelectModule, MatTooltipModule],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div class="flex w-full flex-col gap-2">
        <label for="data" class="whitespace-normal text-justify">{{
          widget.customization.description
        }}</label>
        <div class="p-fluid flex flex-row">
          <p-select
            [autofocus]="false"
            id="data"
            [formControl]="formControl"
            [options]="widget.customization.options"
            [overlayOptions]="{
              onBeforeShow: handleBeforeShow,
            }"
            optionValue="value"
            optionLabel="label"
            class="w-full"
            appendTo="body"
          >
            <ng-template let-data pTemplate="item">
              <p class="whitespace-normal">
                {{ data.label }}
              </p>
            </ng-template>
          </p-select>
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
  providers: [],
})
export class ComboBoxCompiledComponent {
  protected widgetService = inject(
    CompilingWidgetService<ComboBoxCustomization>,
  );

  handleBeforeShow(evt?: OverlayOnBeforeShowEvent) {
    const width = evt?.target?.getBoundingClientRect().width;

    if (evt?.overlay && width) {
      evt.overlay.style.width = `${width}px`;
    }
  }
}
